import { HeaderEditor } from '../../settings-layer/edit-settings-layer/header-editor/HeaderEditor';
import { PreviewHeaderDesktop } from '../../settings-layer/preview-settings-layer/preview-settings-layer-desktop/preview-header-desktop/PreviewHeaderDesktop';
import { PreviewHeaderMobile } from '../../settings-layer/preview-settings-layer/preview-settings-layer-mobile/preview-header-mobile/PreviewHeaderMobile';

type HeaderWrapperProps = {
  isMobile: boolean;
  isPreviewModeActive: boolean;
};

const HeaderWrapper = ({ isMobile, isPreviewModeActive }: HeaderWrapperProps) => {
  const PreviewHeader = isMobile ? PreviewHeaderMobile : PreviewHeaderDesktop;
  return <>{isPreviewModeActive ? <PreviewHeader /> : <HeaderEditor />}</>;
};

export default HeaderWrapper;
